module.exports = __webpack_public_path__ + "static/img/egg_r_18.f4e5438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_18.png
// module id = ty3n
// module chunks = 1